var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClear2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "30px",
    height: "30px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(6.4,6.4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21,24.15l-12.143,12.143l-4.15,-4.15l12.143,-12.143l-12.143,-12.143l4.15,-4.15l12.143,12.143l12.143,-12.143l4.15,4.15l-12.143,12.143l12.143,12.143l-4.15,4.15z",
    fill: "#aba2a2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.143,4.414l3.443,3.443l-11.436,11.436l-0.707,0.707l0.707,0.707l11.436,11.436l-3.443,3.443l-11.436,-11.436l-0.707,-0.707l-0.707,0.707l-11.436,11.436l-3.443,-3.443l11.436,-11.436l0.707,-0.707l-0.707,-0.707l-11.436,-11.436l3.443,-3.443l11.436,11.436l0.707,0.707l0.707,-0.707l11.436,-11.436M33.143,3l-12.143,12.143l-12.143,-12.143l-4.857,4.857l12.143,12.143l-12.143,12.143l4.857,4.857l12.143,-12.143l12.143,12.143l4.857,-4.857l-12.143,-12.143l12.143,-12.143l-4.857,-4.857z",
    fill: "#9d9b9b"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClear2);
export default __webpack_public_path__ + "static/media/clear2.c4791de1d50a1a7b987cd97ca07247a8.svg";
export { ForwardRef as ReactComponent };